import { get_service_endpoint } from 'ServiceEndpoints';
import { flash } from './CommonActions';
import axios from 'axios';
import { createAction } from 'redux-actions';

const GET_ISSUE_PANEL_DATA = createAction('GET_ISSUE_PANEL_DATA');
const GET_PAGINATION_DATA = createAction('GET_PAGINATION_DATA');
const GET_HISTORY_ISSUE_DATA = createAction('GET_HISTORY_ISSUE_DATA');
const fabric = get_service_endpoint('fabric');

export const getIssuePanelData = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${fabric}/orders/raise-issue-list`, { params, isSession: true });
    dispatch(GET_ISSUE_PANEL_DATA(res.data.data.data)); // if data is coming from staging api use this
    dispatch(
      GET_PAGINATION_DATA({ perPageLimit: res.data.data.limit, totalEntries: res.data.data.total }),
    );
  } catch (err) {
    dispatch(
      flash({
        message: err.msg,
      }),
    );
  }
};

export const updateIssueStatus = (inputs) => async (dispatch) => {
  try {
    const res = await axios.patch(
      `${fabric}/orders/${inputs.issueData.orderId}/issue-resolution`,
      inputs,
      { isSession: true },
    );

    if (res.status == 204) {
      dispatch(flash({ message: 'Resolution details submitted successfully!' }));
    }
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response.data.message,
      }),
    );
  }
};

export const initiatePickup = (inputs) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${fabric}/orders/${inputs.orderId}/initiate-pickup`,
      inputs,
      { isSession: true },
    );

    if (res.status == 204) {
      dispatch(flash({ message: 'Return initiated successfully' }));
    }
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response.data.message,
      }),
    );
  }
};

export const getOtpForWhatsAppVerification = (inputs) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${fabric}/whatsapp/otp/send/`,
      inputs,
      { isSession: true },
    );

    if (res.status == 204) {
      dispatch(flash({ message: 'OTP sent successfully!' }));
    }
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response.data.message,
      })
    );
  }
}
export const markIssueResolved = (inputs) => async (dispatch) => {

  try {
    const res = await axios.post(
      `${fabric}/orders/${inputs?.orderId}/mark-issue-resolved`,
      inputs,
      { isSession: true },
    );
    if (res?.data?.success) {
      dispatch(flash({ message: res?.data?.message }));
    }
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response.data.message,
      })
    );
  }
}